<template>
  <UApp :toaster="{ position: 'top-right', duration: 4000 }">
    <NuxtPage />
  </UApp>
</template>
